module.exports = __webpack_public_path__ + "img/like.32c2be4b.gif";